<div class="p-5 mt-50 text-center bg-white">
    <div class="container">
      <a href="javascript:void(0);" (click)="this.navigation();" class="logo" *ngIf="(settings && settings.logo);">
        <img [src]="settings.logo" height="75" alt="logo">
      </a>
    </div>
    <div class="mt-50">
        <h2 class="h3">Votre demande a été envoyée !</h2>
        <p>Vous serez notifié par e-mail à la réception de notre proposition.</p>
    </div>
    <div class="mt-50">
        <button type="button" class="btn btn-primary w-md waves-effect waves-light" (click)="this.navigation();">Revenir à votre espace</button>
    </div>
</div>